import { t } from 'i18n';
import { formatDate } from 'i18n/format';

// Existing notifications contain rendered copy rather than message keys. Match
// only the server's known templates, keeping resource names and custom content.
export function notificationCopy(notification) {
  let { title = '', body = '' } = notification;
  const { type } = notification;
  let match;
  if (type === 'pipeline_failed' && (match = /^Pipeline '(.*)' failed$/s.exec(title))) {
    title = t('shell.notificationPipelineFailed', { name: match[1] });
    const run = /^Run (.*) encountered an error\.$/s.exec(body);
    if (run) body = t('shell.notificationRunFailed', { run: run[1] });
  } else if (type === 'dbt_failed' && (match = /^dbt '(.*)' failed$/s.exec(title))) {
    title = t('shell.notificationDbtFailed', { name: match[1] });
    const run = /^Run (.*) encountered an error\.$/s.exec(body);
    if (run) body = t('shell.notificationRunFailed', { run: run[1] });
  } else if (['pipeline_success', 'pipeline_failed'].includes(type) && (match = /^Backfill of '(.*)' (completed|failed|cancelled|canceled)$/s.exec(title))) {
    title = t(match[2] === 'completed' ? 'shell.notificationBackfillDone' : 'shell.notificationBackfillFailed', { name: match[1] });
    const run = /^Backfill (.*) \[(\d{4}-\d{2}-\d{2}) → (\d{4}-\d{2}-\d{2})\) finished with status: (\w+)\.\s*(.*)$/s.exec(body);
    if (run) body = t('shell.notificationBackfillBody', {
      run: run[1], start: formatDate(run[2]), end: formatDate(run[3]),
      status: t(`shell.${{ success: 'success', failed: 'failed', cancelled: 'cancelled', canceled: 'cancelled' }[run[4]] || 'status'}`), detail: run[5],
    });
  } else if (['connection_offline', 'connection_recovered'].includes(type) && (match = /^Connection '(.*)' (went offline|was disabled|recovered)$/s.exec(title))) {
    const key = { 'went offline': 'notificationConnectionOffline', 'was disabled': 'notificationConnectionDisabled', recovered: 'notificationConnectionRecovered' }[match[2]];
    title = t(`shell.${key}`, { name: match[1] });
    const knownBodies = {
      'Its pipelines have been paused until it is re-enabled; transformations keep running for your other sources.': 'notificationConnectionDisabledBody',
      'Its pipelines have been paused until it recovers; transformations keep running for your other sources.': 'notificationConnectionOfflineBody',
      'Its paused pipelines have been resumed.': 'notificationConnectionRecoveredBody',
    };
    if (knownBodies[body]) body = t(`shell.${knownBodies[body]}`);
  } else if (type === 'dbt_waiting' && (match = /^'(.*)' is waiting for data$/s.exec(title))) {
    title = t('shell.notificationDbtWaiting', { name: match[1] });
    const tables = /^The model has new input but is holding until these tables land: (.*)\. It keeps serving its last complete build meanwhile\.$/s.exec(body);
    if (tables) body = t('shell.notificationDbtWaitingBody', { tables: tables[1] });
  } else if (type === 'account_disconnected' && (match = /^(.*) account disconnected$/s.exec(title))) {
    const provider = match[1];
    title = t('shell.notificationAccountDisconnected', { provider });
    const prefix = `The ${provider} account `;
    const suffix = ' no longer authorizes Evolve Analytics. Reconnect it to resume the pipelines that use it.';
    if (body.startsWith(prefix) && body.endsWith(suffix)) body = t('shell.notificationAccountDisconnectedBody', { provider, account: body.slice(prefix.length, -suffix.length) });
  } else if (type === 'billing_trial_ending' && (match = /^Пробный период заканчивается через (\d+) дн\.$/.exec(title))) {
    title = t('shell.notificationTrialEnding', { count: Number(match[1]) });
    if (body === 'Выберите тариф, чтобы продолжить без пауз.') body = t('shell.notificationChoosePlan');
  } else if (type === 'billing_grace' && title === 'Оплата просрочена') {
    title = t('shell.notificationPaymentOverdue');
    const deadline = /^Если оплата не поступит до (.*), сервис будет приостановлен\.$/.exec(body);
    if (deadline) {
      const date = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(deadline[1]);
      body = t('shell.notificationPaymentDeadline', { date: date ? formatDate(`${date[3]}-${date[2]}-${date[1]}`, { dateStyle: 'medium' }) : t('shell.soon') });
    }
  } else if (type === 'billing_suspended' && title === 'Подписка приостановлена') {
    title = t('shell.notificationSubscriptionSuspended');
    if (body === 'Оплата не поступила — пайплайны и трансформации поставлены на паузу. Данные сохранены и доступны для чтения.') body = t('shell.notificationSubscriptionSuspendedBody');
  } else if (type === 'billing_resumed' && title === 'Подписка снова активна') {
    title = t('shell.notificationSubscriptionResumed');
    if (body === 'Оплата получена — пайплайны и трансформации возобновлены.') body = t('shell.notificationSubscriptionResumedBody');
  }
  return { title, body };
}
